const OfferSpendByOfferScopeListTableLangKey = [
	'column_scope_id',
	'column_scope',
	'column_scope_in_group',
	'column_amount',
	'column_date',
] as const

type IOfferSpendByOfferScopeListTableLangKey = typeof OfferSpendByOfferScopeListTableLangKey[number]

export type IOfferSpendByOfferScopeListTableLang = {
	offer_spend_by_offer_scope_list_table: Record<IOfferSpendByOfferScopeListTableLangKey, string>
}

const langEntries = OfferSpendByOfferScopeListTableLangKey.map(
	(key: IOfferSpendByOfferScopeListTableLangKey) => [key, `offer_spend_by_offer_scope_list_table.${key}`]
)

const langObj: Record<IOfferSpendByOfferScopeListTableLangKey, string> = Object.fromEntries(langEntries)

export const OFFER_SPEND_BY_OFFER_SCOPE_LIST_TABLE_LANG_KEY: IOfferSpendByOfferScopeListTableLang = {
	offer_spend_by_offer_scope_list_table: langObj
}
